import React, { useMemo } from 'react';
import {
  PresentationCol,
  PresentationGrid,
  PresentationRow,
} from '../../../layout/PresentationLayout';
import PaymentSummary from './PaymentSummary';
import PaymentMethodSelector from '../PaymentMethodSelector';
import { PaymentForm } from './PaymentForm';
import { useSelector } from 'react-redux';
import {
  selectPaymentID,
  selectPaymentSignatory,
  selectSelectedPaymentMethod,
  selectPaymentFees,
} from '../../../../store/slices/payment/paymentSelectors';
import { selectConfigSettings } from '../../../../store/slices/config/configSelectors';
import { selectCurrentUserEmail } from '../../../../store/slices/auth/authSelectors';
import IconIndicator from '../../../user-feedback/IconIndicator';

export const Payment = ({
  flow,
  onSuccess,
  permitIdentifier,
  singlePaymentButton = false,
}) => {
  const paymentMethod = useSelector(selectSelectedPaymentMethod);
  const settings = useSelector(selectConfigSettings);
  const provider = settings.paymentProcessor;
  const userEmail = useSelector(selectCurrentUserEmail);
  const signatoryName = useSelector(selectPaymentSignatory);
  const paymentID = useSelector(selectPaymentID);
  const paymentFees = useSelector(selectPaymentFees);

  const hasData = useMemo(() => {
    return !!userEmail && !!signatoryName && !!paymentID && !!paymentMethod;
  }, [userEmail, signatoryName, paymentID, paymentMethod]);

  return (
    <PresentationGrid fluid>
      <PresentationRow>
        <PresentationCol
          xs={24}
          lg={8}
        >
          <PaymentSummary />
        </PresentationCol>
        <PresentationCol
          xs={24}
          lg={16}
        >
          <div className="mb-20">
            <PaymentMethodSelector singlePaymentButton={singlePaymentButton} />
          </div>
          {hasData && (
            <PaymentForm
              onSuccess={onSuccess}
              provider={provider}
              paymentMethod={paymentMethod}
              flow={flow}
              paymentID={paymentID}
              signatoryName={signatoryName}
              userEmail={userEmail}
              fees={paymentFees}
              permitIdentifier={permitIdentifier}
            />
          )}
          {!hasData && <IconIndicator />}
        </PresentationCol>
      </PresentationRow>
    </PresentationGrid>
  );
};

export default Payment;
